import { render, staticRenderFns } from "./CancleModal.vue?vue&type=template&id=2fdf76b3&"
import script from "./CancleModal.vue?vue&type=script&lang=js&"
export * from "./CancleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports